import { gql } from '@apollo/client';
import {
  BASE_COMPANY_USER_FRAGMENT,
  COMPANY_USER_FRAGMENT,
} from '../fragments/compnayUser.fragments';

export const REGISTER_USER = gql`
  mutation RegisterUser($input: UserRegistrationInput!) {
    registerUser(input: $input)
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser($email: String!, $role: UserRole!) {
    inviteUser(email: $email, role: $role) {
      ...baseCompanyUserValues
    }
  }
  ${COMPANY_USER_FRAGMENT}
`;

export const REINVITE_USER = gql`
  mutation ReinviteUser($id: UUID!) {
    reinviteUser(id: $id) {
      ...baseCompanyUserValues
    }
  }
  ${COMPANY_USER_FRAGMENT}
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      ...baseCompanyUserValues
    }
  }
  ${BASE_COMPANY_USER_FRAGMENT}
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: UUID!) {
    deleteUser(id: $id) {
      id
      message
    }
  }
`;

export const UPDATE_ONBOARDING = gql`
  mutation UpdateOnboarding($input: UserOnboardingInput!) {
    onboarding(input: $input) {
      id
      onboarding
    }
  }
`;

export const ACCEPT_TERMS = gql`
  mutation AcceptLatestTerms($input: AcceptLatestTermsInput!) {
    acceptLatestTerms(input: $input) {
      id
      latestTermsAccepted
    }
  }
`;

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation UpdateNotificationSettings($input: UserNotificationsInput!) {
    updateNotificationSettings(input: $input) {
      id
      notifications {
        weeklyRoundup
      }
    }
  }
`;

export const CHANGE_USER_ROLE = gql`
  mutation ChangeUserRole($id: UUID!, $role: UserRole!) {
    changeUserRole(id: $id, role: $role) {
      ...baseCompanyUserValues
    }
  }
  ${BASE_COMPANY_USER_FRAGMENT}
`;

export const VERIFY_USER = gql`
  mutation VerifyUser {
    verifyUser {
      ...baseCompanyUserValues
    }
  }
  ${BASE_COMPANY_USER_FRAGMENT}
`;
